export function formateNumber(number) {
  if (!number) return;
  return number.toLocaleString("en-US");
}
